import { Translate } from 'next-translate';

import { localizeCurrency } from 'common/utils';
import { CartItemOptions, Variant } from '../../../service/types';
import { optionsSelectedPrice } from '.';

type displayCurrentSelectionPriceType = ({
  t,
  selectedVariant,
  selectedOptions,
  currency,
  priceForCurrentSelection,
  lang,
}: {
  t: Translate;
  selectedVariant: Variant;
  selectedOptions: Array<CartItemOptions>;
  currency: Record<string, string>;
  priceForCurrentSelection: number;
  lang: string;
}) => string | number;

export const displayCurrentSelectionPrice: displayCurrentSelectionPriceType = ({
  t,
  selectedVariant,
  selectedOptions,
  currency,
  priceForCurrentSelection,
  lang,
}) => {
  if (selectedVariant?.price === 0 && optionsSelectedPrice({ selectedOptions, selectedVariant }) === 0) {
    return t('price on selection');
  }
  if (currency && !!priceForCurrentSelection) {
    return localizeCurrency(lang, { amount: priceForCurrentSelection, currency: currency.title_en });
  }
  return null;
};
